module.exports = __webpack_public_path__ + "static/hero-what-we-do-c61ade4312e4ec7d728ad50fd0da81f3.png";